module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "quote-request-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper8",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/n1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Budget_request')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "quote-request",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "quote-request__title text-center"
  }, [_vm._v(_vm._s(_vm.$t('Budget_request')))]), _vm._v(" "), (_vm.error) ? _c('message', {
    attrs: {
      "text": _vm.error
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.success_message) ? _c('success-message', {
    attrs: {
      "text": _vm.success_message
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "quote-request__form"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Petitioner_data')))]), _vm._v(" "), _vm._l((_vm.petitioner_fields), function(field) {
    return _c('field', {
      attrs: {
        "name": field.name,
        "type": field.type,
        "placeholder": field.placeholder,
        "autofocus": field.autofocus
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          field.value = $$v
        },
        expression: "field.value"
      }
    })
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Data_of_property_to_be_appraised')))]), _vm._v(" "), _vm._l((_vm.property_fields), function(field) {
    return _c('field', {
      attrs: {
        "name": field.name,
        "type": field.type,
        "placeholder": field.placeholder,
        "autofocus": field.autofocus
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          field.value = $$v
        },
        expression: "field.value"
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v("* " + _vm._s(_vm.$t('Required_fields')))]), _vm._v(" "), (_vm.error) ? _c('message', {
    attrs: {
      "text": _vm.error
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.success_message) ? _c('success-message', {
    attrs: {
      "text": _vm.success_message
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "quote-request__form__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSend($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSend($event)
      }
    }
  }, [_vm._v("\n\t\t\t\tEnviar\n\t\t\t")])], 2)], 1), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00315fee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/QuoteRequest.vue
// module id = 2100
// module chunks = 0